import React from 'react';
import { reduxForm, Field } from 'redux-form';

import InputField from 'components/InputField';
import SelectField from 'components/SelectField';
import FormError from 'components/FormError';
import states from 'helpers/states';

import styles from './styles.module.scss';

const QuickSetAddressForm = ({ handleSubmit, error }) => (
  <form onSubmit={handleSubmit}>
    <div className={styles.row}>
      <div className={styles.item}>
        <Field component={InputField} name="address1" label="Address Line 1" />
      </div>
      <div className={styles.item}>
        <Field component={InputField} name="city" />
      </div>
      <div className={styles.item}>
        <Field
          component={SelectField}
          name="state"
          label="State"
          empty="Choose a state"
          options={states.map((state) => [state.abbreviation, state.name])}
        />
      </div>
      <div className={styles.item}>
        <Field component={InputField} name="zip_code" required />
      </div>
    </div>
    {error && <FormError error={error} />}
    <br />
    <button className="btn btn-primary">Update Address</button>
  </form>
);

const validate = (values) => {
  let errors = {};

  if (!values.zip_code) {
    errors.zip_code = 'Required';
  }

  return errors;
};

export default reduxForm({
  form: 'quickSetAddressForm',
  validate,
  enableReinitialize: true,
})(QuickSetAddressForm);
